/* DO NOT MODIFY. This is an autogenerated file. */
/* eslint-disable */
import * as React from "react"
import type { SVGProps } from "react"

export const SvgRectangle06 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "100%"}
    height={props.height || "100%"}
    fill="none"
    viewBox="0 0 118 24"
    data-name="SvgRectangle06"
    {...props}
  >
    {props.children}
    <path
      fill="#C9DDE9"
      d="M2.003.458H105.35c6.36 0 11.503 5.18 11.459 11.54v.005c.044 6.36-5.099 11.539-11.459 11.539H2.003c-1.23 0-1.966-1.373-1.283-2.398l5.928-8.89.169-.254-.17-.254-5.927-8.89C.037 1.83.772.457 2.003.457"
    />
    <path
      fill="url(#rectangle06_svg__a)"
      fillOpacity={0.4}
      d="M2.003.458H105.35c6.36 0 11.503 5.18 11.459 11.54v.005c.044 6.36-5.099 11.539-11.459 11.539H2.003c-1.23 0-1.966-1.373-1.283-2.398l5.928-8.89.169-.254-.17-.254-5.927-8.89C.037 1.83.772.457 2.003.457"
    />
    <path
      stroke="url(#rectangle06_svg__b)"
      strokeWidth={0.917}
      d="M2.003.458H105.35c6.36 0 11.503 5.18 11.459 11.54v.005c.044 6.36-5.099 11.539-11.459 11.539H2.003c-1.23 0-1.966-1.373-1.283-2.398l5.928-8.89.169-.254-.17-.254-5.927-8.89C.037 1.83.772.457 2.003.457Z"
    />
    <defs>
      <linearGradient
        id="rectangle06_svg__a"
        x1={45.247}
        x2={50.313}
        y1={-2.907}
        y2={24.159}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="rectangle06_svg__b"
        x1={8.314}
        x2={11.697}
        y1={0.45}
        y2={28.51}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.7} />
        <stop offset={0.406} stopColor="#fff" stopOpacity={0.01} />
        <stop offset={0.574} stopColor="#fff" stopOpacity={0.01} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.4} />
      </linearGradient>
    </defs>
  </svg>
)
